// Adapted from example in https://airbnb.io/visx/docs/xychart
import {
	AnimatedAxis, // any of these can be non-animated equivalents
	AnimatedGrid,
	AnimatedLineSeries,
	XYChart,
	Tooltip,
} from '@visx/xychart'

type Props = {
	data: Array<{ x: string; y: number }>
	title: string
}

const accessors = {
	xAccessor: (d: Props['data'][0]) => d.x.slice(6),
	yAccessor: (d: Props['data'][0]) => d.y,
}

const getDomain = (data: Props['data']) => {
	const filtered = data.filter(item => !!item.y)
	const min = Math.min(...filtered.map(item => item.y))
	const max = Math.max(...filtered.map(item => item.y))
	if (min <= 100) {
		return [1, max + 99]
	}
	return [min - 25, max + 25]
}

export default function LineChart(props: Props) {
	return (
		<div className="flex h-full w-full flex-col items-center">
			<label>{props.title}</label>
			<XYChart
				height={225}
				width={undefined}
				xScale={{ type: 'band' }}
				yScale={{ type: 'linear', domain: getDomain(props.data), reverse: true }}
			>
				<AnimatedAxis
					orientation="top"
					tickLabelProps={{ angle: -45, textAnchor: 'start', max: 100 }}
				/>
				<AnimatedGrid columns={false} numTicks={4} />
				<AnimatedLineSeries
					dataKey="Rank by Week"
					colorAccessor={() => '#EAB308'}
					data={props.data}
					{...accessors}
					stroke="#EAB308"
				/>
				<Tooltip
					snapTooltipToDatumX
					snapTooltipToDatumY
					showVerticalCrosshair
					showSeriesGlyphs
					renderTooltip={({ tooltipData, colorScale }) => (
						<div>
							<div>Rank: {accessors.yAccessor(tooltipData.nearestDatum.datum)}</div>
							{/* <div style={{ color: colorScale(tooltipData.nearestDatum.key) }}>
								{tooltipData.nearestDatum.key}
							</div>
							<div>
								<div>Date: {accessors.xAccessor(tooltipData.nearestDatum.datum)}</div>
								<div>Rank: {accessors.yAccessor(tooltipData.nearestDatum.datum)}</div>
							</div> */}
						</div>
					)}
				/>
			</XYChart>
		</div>
	)
}
